import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "@blueprintjs/core";
/**
 * @props {string} iconName
 * @props {string} display
 * @props {function} onClick - required
 */
class IconMinimalButton extends Component {
	render() {
		const { iconName, onClick, display } = this.props;
		return (
			<Button className={this.className()} icon={iconName} onClick={onClick}>
				{display}
			</Button>
		);
	}

	className = () => {
		const { classNameAdd } = this.props;
		const baseClass = "pt-minimal";
		return classNameAdd === "" ? baseClass : baseClass + " " + classNameAdd;
	};
}

IconMinimalButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	iconName: PropTypes.string,
	classNameAdd: PropTypes.string,
	display: PropTypes.string
};

IconMinimalButton.defaultProps = {
	iconName: "chevron-up",
	classNameAdd: "",
	display: ""
};

export default IconMinimalButton;



// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/IconMinimalButton.jsx